/** Batches that never left rows in the ledger, or whose rows were already rolled back. */
export const DELETABLE_FINANCE_IMPORT_STATUSES = [
  'ready',
  'failed',
  'cancelled',
  'rolled_back',
] as const;

export type DeletableFinanceImportStatus = (typeof DELETABLE_FINANCE_IMPORT_STATUSES)[number];

export function canDeleteFinanceImportBatch(status: string): status is DeletableFinanceImportStatus {
  return (DELETABLE_FINANCE_IMPORT_STATUSES as readonly string[]).includes(status);
}
